export enum DataStorage {
    settings = "settings",
    log = "log",
    filter = "filter",
    filterSort = "filtersort",
    document ='document',
    user = 'user'
}